export default __webpack_public_path__ + "static/Plots0000-98c829a3da7dd4617dd54bee571829e9.jpg";